/* FUT7 · Combo — comportamento da área de compra (sections/f7-cb-produto.liquid). Port do script do tnf-combo-product
   da TNF v8, com as regras da FUT7:
   - chaves do cesto: Nome, Número, Badges e _f7_combo (nunca mudam nem se traduzem);
   - nome e número só nas camisolas com a tag `customize` e com os DOIS campos preenchidos (igual ao f7-personalizacao);
   - emblemas pelas tags pXX e pelo registo [data-f7-badge-registry] (snippets/f7-badge-registry), um por posição;
     o valor gravado é a coluna em inglês ("v"), juntada com " + " (igual ao f7-badge-ux);
   - um único POST a /cart/add.js com as camisolas; depois avisa 'cart:updated' e abre o cesto
     (window.f7CartOpen, senão a Upcart, senão a página do cesto).
   Nenhum nome de equipa é escrito aqui. */
(function(){
  'use strict';

  var boot = function(root){
    if (!root || root.dataset.ready) return; root.dataset.ready = '1';
    var D; try { D = JSON.parse(root.querySelector('[data-f7-cb-data]').textContent); } catch (e) { return; }
    var T = D.t || {};
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var ADD_URL = (window.routes && window.routes.cart_add_url) || (ROOT + 'cart/add');
    var CART_URL = (window.routes && window.routes.cart_url) || (ROOT + 'cart');
    var $ = function(s){ return root.querySelector(s); };
    var esc = function(t){ return String(t == null ? '' : t).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var fill = function(s, v){ s = String(s || ''); for (var k in v) s = s.split('[' + k + ']').join(v[k]); return s; };
    var N = D.slots.length, PAID = D.paid;
    var SVG_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var SVG_OK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';
    var SVG_BACK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';

    /* Dinheiro no formato da moeda da visita, lido de um exemplo que o Liquid escreveu (123456 cêntimos).
       products.json e /products/x.js já vêm no preço e na moeda do mercado: não converter de novo. */
    var FMT = (function(s){
      var m = String(s || '').match(/^(\D*)1(\D?)234(?:(\D)56)?(\D*)$/);
      return m ? { pre: m[1], th: m[2], dec: m[3] || '', dp: m[3] ? 2 : 0, suf: m[4] } : null;
    })(D.sample);
    var money = function(c){
      if (!FMT) return (c / 100).toFixed(2);
      var p = (Math.round(c) / 100).toFixed(FMT.dp).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, FMT.th);
      return FMT.pre + p.join(FMT.dec) + FMT.suf;
    };
    var img = function(src, w){ return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; };
    var nice = function(t){ return String(t || '').replace(/\s+(Men[’']?s\s+Long Sleeve|Men[’']?s|Mens|Player Edition|Kids|Women[’']?s|Womens)?\s*Shirt( Kit)?\s*$/i, '').trim(); };

    /* ── Emblemas: registo da FUT7 (código → t mostrado, v gravado, loc posição, i imagens) ── */
    var REG = {};
    try { REG = JSON.parse(document.querySelector('[data-f7-badge-registry]').textContent) || {}; } catch (e) { REG = {}; }
    var LOC_ORDER = { 'Sleeve': 1, 'Left Sleeve': 2, 'Chest': 3, 'Legacy': 4 };
    var locLabel = function(l){ return (T.loc && T.loc[l]) || l || ''; };
    var badgesOf = function(p){
      var seen = {}, out = [];
      (p.tags || []).forEach(function(t){
        var c = String(t).toLowerCase().trim(), e = REG[c];
        if (!/^p\d+[a-d]?$/.test(c) || !e) return;
        var key = (e.v || e.t) + '|' + (e.loc || '');
        if (seen[key]) return; seen[key] = 1;
        out.push({ c: c, t: e.t || e.v, v: e.v || e.t, loc: e.loc || '', i: e.i || [] });
      });
      return out.sort(function(a, b){ return (LOC_ORDER[a.loc] || 9) - (LOC_ORDER[b.loc] || 9); });
    };

    /* ── Produtos e versões (pelo handle, como na TNF) ── */
    /* [parte do handle, versão, ordem]. As partes mais compridas vêm antes (player-edition-men-s-shirt antes de men-s-shirt);
       a ordem (Adepto primeiro) decide que versão representa o modelo na lista de troca. Na FUT7 há as duas escritas
       (men-s / mens) e as variantes da loja portuguesa (player-edition-men-s-shirt, long-sleeve-men-s-shirt, kids-shirt). */
    var TYPES = [['player-edition-men-s-shirt', 'Player', 1], ['long-sleeve-men-s-shirt', 'Long sleeve', 2], ['men-s-long-sleeve-shirt', 'Long sleeve', 2], ['mens-long-sleeve-shirt', 'Long sleeve', 2], ['player-edition-shirt', 'Player', 1], ['men-s-shirt', 'Fan', 0], ['mens-shirt', 'Fan', 0], ['women-s-shirt', 'Women', 3], ['womens-shirt', 'Women', 3], ['kids-shirt-kit', 'Kids', 4], ['kids-shirt', 'Kids', 4]];
    var family = function(h){
      var out = null;
      TYPES.some(function(t){ var key = '-' + t[0] + '-', i = h.indexOf(key); if (i > -1) { out = { pre: h.slice(0, i), suf: h.slice(i + key.length), label: t[1], rank: t[2] }; return true; } return false; });
      return out;
    };
    var vl = function(l){ return (T.ver && Object.prototype.hasOwnProperty.call(T.ver, l) && T.ver[l]) || l; };
    /* Rótulo curto pelo HANDLE: modelo + época ("Principal 26/27"). Mesmo cálculo do Liquid. */
    var slotLabel = function(h, t){
      var hp = String(h || '').toLowerCase().replace('special-edition', 'special_edition'), f = family(hp);
      if (!f) return nice(t);
      var out = [], ok = true, num = false;
      f.pre.split('-').forEach(function(x){
        if (!ok || x === '') return;
        if (/^\d+$/.test(x)) { if (num) out[out.length - 1] += '/' + x; else out.push(x); num = true; return; }
        num = false;
        var w = T.kit && Object.prototype.hasOwnProperty.call(T.kit, x) ? T.kit[x] : '';
        if (!w) { ok = false; return; }
        out.push(w);
      });
      return ok && out.length ? out.join(' ') : nice(t);
    };
    var CACHE = {};
    var load = function(h){
      if (!CACHE[h]) CACHE[h] = fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ delete CACHE[h]; return null; });
      return CACHE[h];
    };
    var VERS = {};
    var versions = function(h){
      if (VERS[h]) return VERS[h];
      var f = family(h), list = [{ h: h, label: f ? f.label : 'Fan' }];
      if (f) TYPES.forEach(function(t){ var c = f.pre + '-' + t[0] + '-' + f.suf; if (c !== h) list.push({ h: c, label: t[1] }); });
      return (VERS[h] = Promise.all(list.map(function(v){ return load(v.h).then(function(p){ v.p = p; return v; }); })).then(function(vs){
        var seen = {};
        return vs.filter(function(v, i){
          if (!v.p || (i > 0 && !v.p.available) || seen[v.label]) return false;
          seen[v.label] = 1; return true;
        });
      }));
    };
    var sizesOf = function(p){ return (p.variants || []).filter(function(v){ return v.title !== 'Default Title'; }); };
    var minPrice = function(p){ return (p.variants || []).reduce(function(m, v){ return m === null || v.price < m ? v.price : m; }, null) || 0; };
    var canCustom = function(p){ return (p.tags || []).some(function(t){ return String(t).toLowerCase() === 'customize'; }); };

    /* ── Lista de troca: camisolas da coleção da equipa, agrupadas por modelo ── */
    var KITS = ['home', 'away', 'third', 'fourth', 'fifth', 'goalkeeper'];
    var EXCL = (D.exclude || []).map(function(x){ return String(x).toLowerCase(); });
    var POOL = null;
    var loadPool = function(){
      if (POOL) return POOL;
      if (!D.pool) return (POOL = Promise.resolve([]));
      var all = [], page = 1;
      var step = function(){
        return fetch(ROOT + 'collections/' + encodeURIComponent(D.pool) + '/products.json?limit=250&page=' + page).then(function(r){ return r.ok ? r.json() : { products: [] }; }).then(function(d){
          var ps = d.products || []; all = all.concat(ps);
          if (ps.length === 250 && page < 4) { page++; return step(); }
          return all;
        });
      };
      return (POOL = step().then(function(ps){
        var fams = {}, order = [];
        ps.forEach(function(p){
          var tags = (p.tags || []).map(function(t){ return String(t).toLowerCase(); });
          if (tags.some(function(t){ return EXCL.indexOf(t) > -1; }) || /^combo-/.test(p.handle)) return;
          if (!(p.variants || []).some(function(v){ return v.available; }) || !(p.images || []).length) return;
          var f = family(p.handle), key = f ? f.pre + '|' + f.suf : p.handle, rank = f ? f.rank : 0;
          var cur = fams[key];
          if (!cur) order.push(key);
          if (!cur || rank < cur.rank) {
            var price = (p.variants || []).reduce(function(m, v){ var x = parseFloat(v.price); return m === null || x < m ? x : m; }, null) || 0;
            var season = '', kit = 99, special = false, retro = tags.indexOf('season-retro') > -1 || tags.indexOf('type-retro') > -1;
            tags.forEach(function(t){
              var m = t.match(/^season-(\d{2})-(\d{2})$/); if (m) season = m[1] + '/' + m[2];
              if (t === 'type-special' || t === 'type-special-edition') special = true;
              var k = KITS.indexOf(t.replace('type-', '')); if (t.indexOf('type-') === 0 && k > -1) kit = Math.min(kit, k);
            });
            fams[key] = { h: p.handle, rank: rank, ver: f ? f.label : 'Fan', title: slotLabel(p.handle, p.title), img: p.images[0].src, price: Math.round(price * 100), season: season, retro: retro, special: special, kit: kit };
          }
        });
        return order.map(function(k){ return fams[k]; }).sort(function(a, b){
          var sa = a.retro ? '00' : (a.season || '01'), sb = b.retro ? '00' : (b.season || '01');
          if (sa !== sb) return sa < sb ? 1 : -1;
          if (a.special !== b.special) return a.special ? 1 : -1;
          return a.kit - b.kit;
        });
      }).catch(function(){ return []; }));
    };

    /* ── Estado: PICK = camisola de cada espaço; CONF = opções guardadas; INFO = título/imagem/preço mostrados ── */
    var PICK = D.slots.map(function(s){ return s.h; }), CONF = [], INFO = [];
    for (var s0 = 0; s0 < N; s0++) { CONF.push(null); INFO.push(null); }
    var CUR = null, VIEW = 'opts', FILTER = '', JUST_SAVED = 0;
    var dlg = $('[data-dlg]'), err = $('[data-error]'), atc = $('[data-atc]');

    var paintRow = function(i){
      var row = root.querySelector('[data-slot="' + i + '"]'), s = CONF[i], inf = INFO[i];
      var st = row.querySelector('[data-slot-state]'), btn = row.querySelector('[data-open]');
      if (inf) { row.querySelector('[data-slot-title]').textContent = inf.title; if (inf.img) row.querySelector('[data-slot-img]').src = img(inf.img, 200); }
      row.classList.toggle('is-done', !!s);
      if (!s) { st.textContent = T.empty; btn.textContent = T.pick; return; }
      var bits = [s.size];
      if (s.vlabel && s.vlabel !== 'Fan') bits.push(vl(s.vlabel));
      if (s.on) bits.push((s.name + ' ' + s.num).trim());
      if (s.badges.length) bits.push(fill(s.badges.length > 1 ? T.badgeN : T.badgeOne, { n: s.badges.length }));
      st.textContent = bits.join(' · ');
      btn.textContent = T.change;
    };

    var paintFoot = function(){
      var prices = [], done = 0;
      for (var i = 0; i < N; i++) { prices.push(CONF[i] ? CONF[i].price : (INFO[i] ? INFO[i].from : D.slots[i].from)); if (CONF[i]) done++; }
      /* Pagam-se as PAID mais caras; as restantes contam a zero ("a mais barata é grátis") */
      var idx = prices.map(function(p, k){ return k; }).sort(function(a, b){ return prices[b] - prices[a] || a - b; });
      var gross = 0, pay = 0, free = {};
      idx.forEach(function(k, r){ gross += prices[k]; if (r < PAID) pay += prices[k]; else free[k] = 1; });
      var all = done === N;
      $('[data-progress]').textContent = done + '/' + N + ' ' + T.ready;
      root.querySelectorAll('[data-step]').forEach(function(s){ s.classList.toggle('is-on', !!CONF[+s.dataset.step]); });
      root.querySelectorAll('[data-pack-shirt]').forEach(function(s){
        var k = +s.dataset.packShirt, inf = INFO[k];
        s.classList.toggle('is-on', !!CONF[k]); s.classList.toggle('is-free', !!free[k]);
        if (inf && inf.img) s.querySelector('img').src = img(inf.img, 160);
      });
      $('[data-total-label]').textContent = all ? T.total : T.totalFrom;
      $('[data-total]').textContent = money(pay);
      var sv = $('[data-total-save]');
      sv.hidden = gross <= pay;
      sv.innerHTML = esc(T.youSave).split('[amount]').join('<b>' + esc(money(gross - pay)) + '</b>');
      $('[data-atc-label]').textContent = all ? T.atc : T.atcBuild;
      $('[data-atc-sub]').textContent = all ? fill(T.atcSub, { amount: money(pay), n: N }) : fill(T.atcBuildSub, { left: N - done });
      $('[data-sticky-price]').textContent = (all ? '' : T.totalFrom + ' ') + money(pay);
      $('[data-sticky-btn]').textContent = all ? T.atc : T.atcBuild;
      $('[data-pack]').classList.toggle('is-ready', all);
      $('[data-atc-count]').textContent = done;
      /* Próximo passo: a primeira camisola que ainda falta */
      var nb = $('[data-next]'), nx = 0;
      while (nx < N && CONF[nx]) nx++;
      nb.hidden = all;
      if (!all) {
        var nt = root.querySelector('[data-slot="' + nx + '"] [data-slot-title]');
        nb.dataset.open = nx;
        $('[data-next-num]').textContent = nx + 1;
        $('[data-next-text]').innerHTML = esc(T.next).split('[shirt]').join('<b>' + esc(nt ? nt.textContent : '') + '</b>');
      }
      if (all) err.hidden = true;
    };

    var close = function(){ if (dlg.close && dlg.open) dlg.close(); else dlg.removeAttribute('open'); };
    var show = function(){ if (dlg.showModal && !dlg.open) dlg.showModal(); else dlg.setAttribute('open', ''); };
    var wait = function(){ dlg.innerHTML = '<div class="f7-cb__dbody"><div class="f7-cb__wait"><i></i><p>' + esc(T.loading) + '</p></div></div>'; };
    var head = function(i, title, sub, thumb, back){
      return '<div class="f7-cb__dhead">' +
        (back ? '<button type="button" class="f7-cb__x f7-cb__x--back" data-back aria-label="' + esc(T.back) + '">' + SVG_BACK + '</button>' : '') +
        (thumb ? '<img src="' + esc(img(thumb, 160)) + '" alt="" width="52" height="52">' : '') +
        '<span class="f7-cb__dtitle"><small>' + esc(T.shirt) + ' ' + (i + 1) + ' ' + esc(T.of) + ' ' + N + '</small><b>' + esc(title) + '</b>' + (sub ? '<span>' + esc(sub) + '</span>' : '') + '</span>' +
        '<button type="button" class="f7-cb__x" data-close aria-label="' + esc(T.close) + '">' + SVG_X + '</button></div>';
    };

    /* ── Popup: opções da camisola escolhida ── */
    var openSlot = function(i, prefill){
      wait(); show();
      var prev = CONF[i];
      versions(PICK[i]).then(function(vs){
        if (!vs.length) throw 0;
        var v = vs[0];
        if (prev) vs.forEach(function(x){ if (x.h === prev.h) v = x; });
        CUR = { i: i, vs: vs, v: v, size: prev ? prev.size : null, on: prev ? prev.on : false, name: prev ? prev.name : '', num: prev ? prev.num : '', badges: prev ? prev.badges.slice() : [] };
        if (prefill) { CUR.on = prefill.on; CUR.name = prefill.name; CUR.num = prefill.num; }
        VIEW = 'opts'; draw();
      }).catch(function(){
        dlg.innerHTML = head(i, T.loadErr, '', '', false) + '<div class="f7-cb__dbody"></div>';
      });
    };

    var draw = function(){
      var c = CUR, p = c.v.p, base = minPrice(c.vs[0].p);
      if (!canCustom(p)) c.on = false;
      var h = head(c.i, slotLabel(c.v.h, p.title), vl(c.v.label), p.featured_image, false) + '<div class="f7-cb__dbody">';
      if (JUST_SAVED) { h += '<p class="f7-cb__saved">' + SVG_OK + '<span>' + esc(fill(T.savedNote, { i: JUST_SAVED, n: c.i + 1, total: N })) + '</span></p>'; JUST_SAVED = 0; }
      h += '<button type="button" class="f7-cb__swap" data-swap><span class="f7-cb__swap-ico" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M7 7h11l-3-3M17 17H6l3 3"/></svg></span>' +
        '<span class="f7-cb__swap-copy"><b>' + esc(T.swap) + '</b>' + (T.swapSub ? '<small>' + esc(T.swapSub) + '</small>' : '') + '</span>' +
        '<span class="f7-cb__swap-thumbs" data-swap-thumbs aria-hidden="true"></span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>';

      if (c.vs.length > 1) {
        h += '<div class="f7-cb__dgroup"><div class="f7-cb__label"><b>' + esc(T.version) + '</b><span>' + esc(vl(c.v.label)) + '</span></div><div class="f7-cb__vers">';
        c.vs.forEach(function(x, k){
          var d = minPrice(x.p) - base;
          h += '<button type="button" class="f7-cb__ver" data-ver="' + k + '"><b>' + esc(vl(x.label)) + '</b><span>' + (d > 0 ? '+' + esc(money(d)) : esc(money(minPrice(x.p)))) + '</span></button>';
        });
        h += '</div></div>';
      }

      h += '<div class="f7-cb__dgroup"><div class="f7-cb__label"><b>' + esc(T.size) + '</b><span data-size-now>' + esc(c.size || '') + '</span></div><div class="f7-cb__sizes">';
      sizesOf(p).forEach(function(v){ h += '<button type="button" class="f7-cb__size" data-size="' + esc(v.title) + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>'; });
      h += '</div>' + (T.sizeHint ? '<p class="f7-cb__hint">' + esc(T.sizeHint) + '</p>' : '') + '</div>';

      if (canCustom(p)) {
        h += '<div class="f7-cb__dgroup"><div class="f7-cb__label"><b>' + esc(T.nn) + '</b></div><div class="f7-cb__nn-btns">' +
          '<button type="button" class="f7-cb__nn-btn" data-nn="off">' + esc(T.nnOff) + '</button>' +
          '<button type="button" class="f7-cb__nn-btn" data-nn="on">' + esc(T.nnOn) + ' <em>' + esc(T.nnFree) + '</em></button></div>' +
          '<div class="f7-cb__nn" data-nn-fields hidden><input class="f7-cb__field" type="text" maxlength="15" autocomplete="off" spellcheck="false" placeholder="' + esc(T.namePh) + '" aria-label="' + esc(T.namePh) + '" data-name>' +
          '<input class="f7-cb__field f7-cb__field--num" type="text" inputmode="numeric" maxlength="2" autocomplete="off" placeholder="' + esc(T.numPh) + '" aria-label="' + esc(T.numPh) + '" data-num></div>' +
          (T.nnNote ? '<p class="f7-cb__hint" data-nn-note hidden>' + esc(T.nnNote) + '</p>' : '') + '</div>';
      }

      var bs = badgesOf(p);
      if (bs.length) {
        h += '<div class="f7-cb__dgroup"><div class="f7-cb__label"><b>' + esc(T.badges) + '</b><span>' + esc(T.badgesHint) + '</span></div><div class="f7-cb__badges">';
        bs.forEach(function(b){
          h += '<button type="button" class="f7-cb__badge" data-badge="' + esc(b.c) + '" data-loc="' + esc(b.loc) + '">' +
            (b.i.length ? '<img src="' + esc(b.i[0]) + '" alt="" width="44" height="44" loading="lazy" data-n="0">' : '<span class="f7-cb__badge-ph" aria-hidden="true"></span>') +
            '<span><b>' + esc(b.t) + '</b><small>' + esc(locLabel(b.loc)) + '</small></span><i aria-hidden="true"></i></button>';
        });
        h += '</div></div>';
      }

      h += '</div><div class="f7-cb__dfoot"><span class="f7-cb__dprice" data-dprice></span><button type="button" class="f7-cb__dsave" data-save disabled>' + esc(T.save) + '</button></div>';
      dlg.innerHTML = h;
      /* Emblema: o registo dá uma lista de candidatas (.png, .jpg…); falhou uma, tenta a seguinte; esgotadas, fica o marcador */
      dlg.querySelectorAll('.f7-cb__badge img').forEach(function(im){
        var b = bs.filter(function(x){ return x.c === im.parentNode.getAttribute('data-badge'); })[0];
        var next = function(){
          var n = +im.getAttribute('data-n') + 1;
          if (b && n < b.i.length) { im.setAttribute('data-n', n); im.src = b.i[n]; return; }
          var ph = document.createElement('span'); ph.className = 'f7-cb__badge-ph'; ph.setAttribute('aria-hidden', 'true');
          im.parentNode.replaceChild(ph, im);
        };
        im.addEventListener('error', next);
        if (im.complete && !im.naturalWidth) next();
      });
      var nm =dlg.querySelector('[data-name]'), nu = dlg.querySelector('[data-num]');
      if (nm) nm.value = c.name;
      if (nu) nu.value = c.num;
      c.badges = c.badges.filter(function(code){ return bs.some(function(b){ return b.c === code; }); });
      c.bs = bs;
      paint();
      /* Miniaturas no botão de troca: uma da época, uma especial e uma retro */
      loadPool().then(function(list){
        var box = dlg.querySelector('[data-swap-thumbs]'); if (!box) return;
        var pick = [], take = function(fn){ for (var k = 0; k < list.length; k++) { var f = list[k]; if (f.h !== PICK[c.i] && pick.indexOf(f) === -1 && fn(f)) { pick.push(f); return; } } };
        take(function(f){ return !f.retro && !f.special; }); take(function(f){ return f.special; }); take(function(f){ return f.retro; });
        box.innerHTML = pick.map(function(f){ return '<img src="' + esc(img(f.img, 80)) + '" alt="" width="30" height="30">'; }).join('');
      });
    };

    var paint = function(){
      var c = CUR; if (!c || VIEW !== 'opts') return;
      var p = c.v.p, v = null;
      sizesOf(p).forEach(function(x){ if (x.title === c.size) v = x; });
      if (v && !v.available) { v = null; c.size = null; }
      dlg.querySelectorAll('[data-ver]').forEach(function(b){ b.classList.toggle('is-on', c.vs[+b.dataset.ver] === c.v); });
      dlg.querySelectorAll('[data-size]').forEach(function(b){ b.classList.toggle('is-on', b.dataset.size === c.size); });
      var sn = dlg.querySelector('[data-size-now]'); if (sn) sn.textContent = c.size || '';
      dlg.querySelectorAll('[data-nn]').forEach(function(b){ b.classList.toggle('is-on', (b.dataset.nn === 'on') === c.on); });
      var fields = dlg.querySelector('[data-nn-fields]'); if (fields) fields.hidden = !c.on;
      var note = dlg.querySelector('[data-nn-note]'); if (note) note.hidden = !c.on;
      dlg.querySelectorAll('[data-badge]').forEach(function(b){ b.classList.toggle('is-on', c.badges.indexOf(b.dataset.badge) > -1); });
      dlg.querySelector('[data-dprice]').textContent = money(v ? v.price : minPrice(p));
      /* Igual à página de produto: com "Personalizar" ligado, nome E número são obrigatórios */
      var nnOk = !c.on || (c.name.trim() && c.num.trim());
      var sv = dlg.querySelector('[data-save]');
      sv.disabled = !(v && nnOk);
      sv.textContent = !v ? T.needSize : (!nnOk ? T.needNN : T.save);
      c.variant = v;
    };

    /* ── Popup: trocar a camisola por outra da equipa ── */
    var drawPicker = function(i){
      VIEW = 'pick';
      var cur = PICK[i];
      dlg.innerHTML = head(i, T.pickTitle, '', '', true) + '<div class="f7-cb__dbody"><div class="f7-cb__wait"><i></i><p>' + esc(T.loading) + '</p></div></div>';
      var keep = CUR;
      loadPool().then(function(list){
        if (VIEW !== 'pick') return;
        var tabs = [['', T.all]], seen = {};
        list.forEach(function(f){
          var k = f.retro ? 'retro' : (f.special ? 'special' : f.season);
          if (k && !seen[k]) { seen[k] = 1; tabs.push([k, k === 'retro' ? T.retro : (k === 'special' ? T.special : k)]); }
        });
        tabs.sort(function(a, b){ var r = function(x){ return x[0] === '' ? 0 : x[0] === 'special' ? 2 : x[0] === 'retro' ? 3 : 1; }; return r(a) - r(b) || (a[0] < b[0] ? 1 : -1); });
        var h = '<div class="f7-cb__tabs">' + tabs.map(function(t){ return '<button type="button" class="f7-cb__tab' + (FILTER === t[0] ? ' is-on' : '') + '" data-tab="' + esc(t[0]) + '">' + esc(t[1]) + '</button>'; }).join('') + '</div><div class="f7-cb__grid">';
        var curFam = family(cur), curKey = curFam ? curFam.pre + '|' + curFam.suf : cur;
        list.forEach(function(f, k){
          var key = f.retro ? 'retro' : (f.special ? 'special' : f.season);
          var ff = family(f.h), fk = ff ? ff.pre + '|' + ff.suf : f.h;
          h += '<button type="button" class="f7-cb__opt' + (fk === curKey ? ' is-on' : '') + '" data-fam="' + k + '" data-key="' + esc(key) + '"' + (FILTER && FILTER !== key ? ' hidden' : '') + '>' +
            '<img src="' + esc(img(f.img, 300)) + '" alt="" width="150" height="150" loading="lazy"><b>' + esc(f.title) + '</b><span>' + (f.ver !== 'Fan' ? esc(vl(f.ver)) + ' · ' : '') + esc(money(f.price)) + '</span></button>';
        });
        h += '</div>';
        dlg.querySelector('.f7-cb__dbody').innerHTML = list.length ? h : '<p class="f7-cb__hint">' + esc(T.loadErr) + '</p>';
        CUR = { i: i, list: list, prev: keep };
      });
      CUR = { i: i, list: [], prev: keep };
    };

    var save = function(){
      var c = CUR; if (!c || !c.variant) return;
      var p = c.v.p;
      var on = c.on && !!(c.name.trim() && c.num.trim());
      CONF[c.i] = {
        h: c.v.h, vlabel: c.v.label, vid: c.variant.id, price: c.variant.price, size: c.size,
        on: on, name: on ? c.name.trim() : '', num: on ? c.num.trim() : '',
        badges: c.badges.slice(),
        badgeVals: (c.bs || []).filter(function(b){ return c.badges.indexOf(b.c) > -1; }).map(function(b){ return b.v; })
      };
      INFO[c.i] = { title: slotLabel(c.v.h, p.title), img: p.featured_image, from: c.variant.price };
      var i = c.i; CUR = null;
      paintRow(i); paintFoot();
      var sb = dlg.querySelector('[data-save]');
      if (sb) { sb.disabled = true; sb.classList.add('is-saved'); sb.innerHTML = SVG_OK + esc(T.saved); }
      /* A próxima camisola vazia abre sozinha (com o aviso de guardada) */
      var nxt = -1;
      for (var k = 1; k <= N; k++) { var j = (i + k) % N; if (!CONF[j]) { nxt = j; break; } }
      setTimeout(function(){
        close();
        if (nxt > -1) { JUST_SAVED = i + 1; setTimeout(function(){ openSlot(nxt); }, 260); }
      }, 550);
    };

    dlg.addEventListener('click', function(e){
      var t = e.target, b;
      if (t === dlg || t.closest('[data-close]')) { CUR = null; close(); return; }
      if (!CUR) return;
      if (VIEW === 'pick') {
        if (t.closest('[data-back]')) { openSlot(CUR.i); return; }
        if ((b = t.closest('[data-tab]'))) {
          FILTER = b.dataset.tab;
          dlg.querySelectorAll('[data-tab]').forEach(function(x){ x.classList.toggle('is-on', x === b); });
          dlg.querySelectorAll('[data-fam]').forEach(function(x){ x.hidden = !!FILTER && x.dataset.key !== FILTER; });
          return;
        }
        if ((b = t.closest('[data-fam]'))) {
          var f = CUR.list[+b.dataset.fam], i = CUR.i, old = CONF[i];
          if (!f) return;
          if (PICK[i] !== f.h) {
            PICK[i] = f.h; CONF[i] = null;
            INFO[i] = { title: f.title, img: f.img, from: f.price };
            paintRow(i); paintFoot();
          }
          openSlot(i, old ? { on: old.on, name: old.name, num: old.num } : null);
        }
        return;
      }
      if (t.closest('[data-swap]')) { drawPicker(CUR.i); return; }
      if ((b = t.closest('[data-ver]'))) {
        var nv = CUR.vs[+b.dataset.ver]; if (nv === CUR.v) return;
        CUR.v = nv;
        if (!sizesOf(nv.p).some(function(x){ return x.title === CUR.size && x.available; })) CUR.size = null;
        draw(); return;
      }
      if ((b = t.closest('[data-size]')) && !b.disabled) { CUR.size = b.dataset.size; paint(); return; }
      if ((b = t.closest('[data-nn]'))) {
        CUR.on = b.dataset.nn === 'on'; paint();
        var nmf = dlg.querySelector('[data-name]');
        if (CUR.on && nmf) nmf.focus({ preventScroll: true });
        return;
      }
      if ((b = t.closest('[data-badge]'))) {
        /* Um emblema por posição: escolher outro da mesma posição troca o anterior */
        var code = b.dataset.badge, loc = b.dataset.loc, k = CUR.badges.indexOf(code);
        if (k > -1) CUR.badges.splice(k, 1);
        else {
          CUR.badges = CUR.badges.filter(function(x){ var o = (CUR.bs || []).filter(function(bb){ return bb.c === x; })[0]; return !o || !loc || o.loc !== loc; });
          CUR.badges.push(code);
        }
        paint(); return;
      }
      if (t.closest('[data-save]')) save();
    });
    dlg.addEventListener('input', function(e){
      if (!CUR || VIEW !== 'opts') return;
      /* Mesmas regras do f7-personalizacao: nome em maiúsculas sem algarismos; número só algarismos, até 2 */
      if (e.target.matches('[data-name]')) { e.target.value = e.target.value.replace(/[0-9]/g, '').toUpperCase().replace(/\s{2,}/g, ' '); CUR.name = e.target.value; paint(); }
      if (e.target.matches('[data-num]')) { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 2); CUR.num = e.target.value; paint(); }
    });
    dlg.addEventListener('close', function(){ CUR = null; });

    root.addEventListener('click', function(e){
      var b = e.target.closest('[data-open]');
      if (b && !dlg.contains(b)) { err.hidden = true; openSlot(+b.dataset.open); }
    });

    /* ── Cesto: UM POST com todas as camisolas ── */
    var openCart = function(){
      if (typeof window.f7CartOpen === 'function') { try { window.f7CartOpen(); return; } catch (e) {} }
      var did = 0;
      if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); did++; } catch (e) {} }
      if (typeof window.upcartOpenCart === 'function') { try { window.upcartOpenCart(); did++; } catch (e) {} }
      if (!did) window.location.href = CART_URL;
    };
    var add = function(){
      for (var i = 0; i < N; i++) if (!CONF[i]) { openSlot(i); return; }
      var items = CONF.map(function(s){
        var pr = {};
        if (s.on && s.name && s.num) { pr['Nome'] = s.name; pr['Número'] = s.num; }
        if (s.badgeVals && s.badgeVals.length) pr['Badges'] = s.badgeVals.join(' + ');
        pr['_f7_combo'] = D.handle;
        return { id: s.vid, quantity: 1, properties: pr };
      });
      atc.disabled = true; atc.classList.add('is-loading');
      $('[data-atc-label]').textContent = T.adding;
      fetch(ADD_URL + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
        .then(function(res){
          for (var k = 0; k < N; k++) { CONF[k] = null; paintRow(k); }
          paintFoot();
          try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'f7-cb', combo: D.handle, items: res && res.items } })); } catch (e) {}
          openCart();
        })
        .catch(function(j){ err.textContent = (j && (j.description || j.message)) || T.addErr; err.hidden = false; })
        .then(function(){ atc.disabled = false; atc.classList.remove('is-loading'); paintFoot(); });
    };
    atc.addEventListener('click', add);
    $('[data-sticky-btn]').addEventListener('click', add);

    /* ── Galeria: pontos acompanham a rolagem ── */
    var slides = $('[data-slides]'), dots = $('[data-dots]'), count = slides.children.length;
    if (count > 1) {
      dots.innerHTML = new Array(count + 1).join('<i></i>');
      var setDot = function(){ var k = Math.round(slides.scrollLeft / slides.clientWidth); [].forEach.call(dots.children, function(d, x){ d.classList.toggle('is-on', x === k); }); };
      slides.addEventListener('scroll', setDot, { passive: true }); setDot();
    }

    /* ── Barra fixa quando o resumo do pack sai do ecrã ── */
    var sticky = $('[data-sticky]');
    if ('IntersectionObserver' in window) new IntersectionObserver(function(es){
      var on = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      sticky.querySelector('button').tabIndex = on ? 0 : -1;
    }).observe(atc);

    for (var r0 = 0; r0 < N; r0++) paintRow(r0);
    paintFoot();

    /* Pré-carga só das versões (leve). A lista de troca só é pedida quando o cliente abre uma camisola. */
    var idle = window.requestIdleCallback || function(f){ return setTimeout(f, 300); };
    var pre = function(){ PICK.forEach(function(h, k){ setTimeout(function(){ versions(h); }, k * 250); }); };
    if (document.readyState === 'complete') idle(pre); else window.addEventListener('load', function(){ idle(pre); });
  };

  var start = function(){ document.querySelectorAll('[data-f7-cb]').forEach(boot); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
